module.exports = fox._r("fonts/robotocondensed-italic-webfont.svg", __webpack_public_path__ + "_/_/_/root/fonts/robotocondensed-italic-webfont.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-italic-webfont.svg
// module id = 182
// module chunks = 4